import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-important-items-ferias',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './important-items-ferias.component.html',
  styleUrl: './important-items-ferias.component.css'
})
export class ImportantItemsFeriasComponent {


  listItems = [
    {
      texto: "Fomenta la conciencia sobre la prevención de enfermedades y hábitos saludables.",
    },
    {
      texto: "Promueve la participación activa de los colaboradores en su propio bienestar."
    },
    {
      texto: "Mejora el ambiente laboral al ofrecer información accesible y soluciones de salud."
    },
    {
      texto: "Refuerza una cultura empresarial orientada al cuidado integral de los colaboradores."
    }

  ]


}
